import { Center, Spinner, Text, VStack } from "@chakra-ui/react"
import React, { useCallback, useEffect, useState } from "react"
import { UsersByTypeQueryVariables, useUsersByTypeQuery } from "../../graphql"
import { UsersList } from "./UsersList"

export type UsersByTypeProps = {
	typeId: string
}

export const UsersByType: React.FC<UsersByTypeProps> = ({ typeId }) => {
	const [filter, setFilter] = useState({ typeId })

	const [pagination, setPagination] = useState<UsersByTypeQueryVariables["pagination"]>({ limit: 20, page: 1 })

	const [{ data, fetching, error }] = useUsersByTypeQuery({
		variables: { ...filter, pagination },
	})

	useEffect(() => {
		const timeoutId = setTimeout(() => {
			setFilter({ typeId })
		}, 1000)

		return () => {
			clearTimeout(timeoutId)
		}
	}, [typeId])

	const nextPage = useCallback(() => {
		if (fetching) return

		if (data?.usersByType.hasNextPage) {
			setPagination((prev) => ({
				...prev,
				page: (prev.page || 0) + 1,
			}))
		}
	}, [data, fetching])

	return (
		<VStack w="full" maxW="2xl" align="stretch">
			{fetching && !data?.usersByType ? (
				<Center w="full" py="4">
					<VStack w="full" color="grayscale.label">
						<Text fontSize="sm">Loading users</Text>
						<Spinner size="sm" />
					</VStack>
				</Center>
			) : error ? (
				<Center py="4">
					<Text fontSize="sm" fontWeight="semibold" color="error.500">
						{error.message.replace("[GraphQL] ", "")}
					</Text>
				</Center>
			) : data?.usersByType.users && data.usersByType.users.length ? (
				<VStack w="full" align="stretch">
					<Text>
						Showing {data.usersByType.users.length || 0} user
						{(data.usersByType.users.length || 0) > 1 ? "s" : ""}
					</Text>

					<UsersList users={data.usersByType.users} loadMore={nextPage} />

					{fetching && (
						<Center w="full" py="4">
							<VStack w="full" color="grayscale.label">
								<Text fontSize="sm">Loading more users</Text>
								<Spinner size="sm" />
							</VStack>
						</Center>
					)}
				</VStack>
			) : (
				<Center py="4">
					<Text fontSize="sm" fontWeight="semibold" color="error.500">
						Couldn&apos;t find any users.
					</Text>
				</Center>
			)}
		</VStack>
	)
}
